var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "maintenance-modal" } }, [
    _c("div", { staticClass: "maintenance-mask" }, [
      _c("div", { staticClass: "maintenance-body" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }